module.exports = __webpack_public_path__ + "static/media/sy_dummies_ppt_pic_2.7169cf30.png";